import type { PrimaryPalette } from '~/domain/shared/branding/models/PrimaryPalette'

export const BagyPrimaryPalette: PrimaryPalette = {
  50: '#FBEAF2',
  100: '#FBDAE8',
  200: '#F5B8D2',
  300: '#EC83AF',
  400: '#D5588D',
  500: '#C93672',
  600: '#A22F60',
  700: '#7D264D',
  800: '#591D39',
  900: '#351323',
  950: '#1a0812'
}
